import searchDoctor from "../images/Frame.svg";
import onlinePharm from "../images/drug.svg";
import consultation from "../images/phone.svg";
import detailsInfo from "../images/detailsInfo.svg";
import emergencyCare from "../images/emergency.svg";
import tracking from "../images/tracking.svg";

import articleOne from "../images/article-one.jpg";
import articleTwo from "../images/article-two.jpg";
import articleThree from "../images/article-three.jpg";

export const services = [
  {
    id: 1,
    icon: searchDoctor,
    title: "Search Doctor",
    content:
      "Choose your doctor from thousands of specialist, general, and trusted hospitals",
  },
  {
    id: 2,
    icon: onlinePharm,
    title: "Online Pharmacy",
    content:
      "Buy your medicines with our mobile application with a simple delivery system",
  },
  {
    id: 3,
    icon: consultation,
    title: "Consultation",
    content:
      "Free consultation with our trusted doctors and get the best recommendations",
  },
  {
    id: 4,
    icon: detailsInfo,
    title: "Details info",
    content:
      "Free consultation with our trusted doctors and get the best recommendations",
  },
  {
    id: 5,
    icon: emergencyCare,
    title: "Emergency care",
    content:
      "You can get 24/7 urgent care for yourself or your children and your lovely family",
  },
  {
    id: 6,
    icon: tracking,
    title: "Tracking",
    content: "Track and save your medical history and health data",
  },
];

export const articles = [
  {
    id: 1,
    img: articleOne,
    topic: "Disease detection, check up in the laboratory",
    content:
      "In this case, the role of the health laboratory is very important to do a disease detection...",
  },
  {
    id: 2,
    img: articleTwo,
    topic: "Herbal medicines that are safe for consumption",
    content:
      "Herbal medicines is very widely used at this time because its very good for your health...",
  },
  {
    id: 3,
    img: articleThree,
    topic: "Natural care for healthy facial skin",
    content:
      "A healthy lifestyle should start from now and also for your skin health. There are some...",
  },
];

export const navbarLinks = [
  {
    name: "Home",
    address: "#",
  },
  {
    name: "Find a doctor",
    address: "#",
  },
  {
    name: "Apps",
    address: "#",
  },
  {
    name: "Testimonials",
    address: "#",
  },
  {
    name: "About us",
    address: "#",
  },
];
